/**
 * GLOBAL resize handler
 *
 */

// A generic debounce function to improve performance
export function debounce(func, delay) {
	let timer;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => func.apply(this, args), delay);
	};
}

